module.exports = __webpack_public_path__ + "img/info4-bg.555a658e.svg";